/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Box } from '@mui/material';
import { FC } from 'react';

export const SpotBottomRight: FC = () => (
	<Box mt={'10px'} height={'100px'}>
		<ContentRecommendation
			id="pdp-bottom-right-content-recommendation"
			properties={{
				emsName: `DPV2_ContentRecommendation_PDP_BottomRight_Spot`,
			}}
		/>
	</Box>
);

export const SpotBackToSchool: FC = () => (
	<ContentRecommendation
		id="pdp-back-to-school-content-recommendation"
		properties={{
			emsName: `DPV2_ContentRecommendation_PDP_BackToSchool_Spot`,
		}}
	/>
);

export const SpotCarousels: FC = () => (
	<ContentRecommendation
		id="pdp-carousel-content-recommendation"
		properties={{
			emsName: `DPV2_ContentRecommendation_PDP_Carousels_Spot`,
		}}
	/>
);
